export enum MppUserLanguage {
  EN = 'en',
  FR = 'fr',
}
